import type { FlowTypes } from 'store/constants';
import { isDepositFlowType } from 'utils';

import { Routes } from '../../routes';

export const getMethodListPath = (flowType: FlowTypes) => {
  const baseRoute = isDepositFlowType(flowType) ? Routes.deposit : Routes.withdrawal;
  const { search = '' } = window.location;
  return {
    pathname: baseRoute,
    search,
  };
};
